import { render, staticRenderFns } from "./GatewayList.vue?vue&type=template&id=0c970adf&scoped=true"
import script from "./GatewayList.vue?vue&type=script&lang=js"
export * from "./GatewayList.vue?vue&type=script&lang=js"
import style0 from "./GatewayList.vue?vue&type=style&index=0&id=0c970adf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c970adf",
  null
  
)

export default component.exports